export default __webpack_public_path__ + "static/media/ban-solid.7402906c.svg";